import "./assets/public_shell.scss";

import { bootstrapLocalDebugOverlays } from "@/helpers/debug/bootstrapLocalDebugOverlays";
import { registerVueOverlayRootDirective } from "@/directives/vueOverlayRoot";
import { initLegacyFlowbiteGlobals } from "@/helpers/legacy/initLegacyFlowbiteGlobals";
import { createSsrHydrationToggle, shouldHydrateSSRIslands } from "@/helpers/ssrHydrationToggle";
import { registerOfflineMirrorSw } from "@/helpers/registerOfflineMirrorSw";

async function mountAiChartPrices() {
  const [{ createPinia }, { createDebuggableVueApp }, { default: AiChartPrices }] = await Promise.all([
    import("pinia"),
    import("@/helpers/debug/vueDebugOverlay"),
    import("@/components/public/micro/AiChartPrices.vue"),
  ]);

  const app = createDebuggableVueApp(AiChartPrices, { showCompletionEta: false });
  registerVueOverlayRootDirective(app);
  app.use(createPinia()).mount(".vue-job-li-ai-chart-prices");
}

bootstrapLocalDebugOverlays();
initLegacyFlowbiteGlobals();
registerOfflineMirrorSw();

if (document.querySelector(".vue-job-li-ai-chart-prices")) {
  void mountAiChartPrices();
}

createSsrHydrationToggle();

if (shouldHydrateSSRIslands() && document.querySelector("[data-vue-ssr-component]")) {
  import("./hydrate-ssr").then(({ hydrateSSRIslands }) => {
    hydrateSSRIslands();
  });
}
